import React, { useEffect, useState } from "react";
import { Input, Label } from "reactstrap";
import TimezonePicker from "react-timezone";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import DatePicker from "react-datepicker";
// import Select from "react-select";
import Select, { components } from "react-select";
import countries from "./contry.json";
import { getValue } from "@utils/lodash";
import DropdownArrowSvgComponent from "../assets/svg-components/dropdown-arrow";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <DropdownArrowSvgComponent />
    </components.DropdownIndicator>
  );
};

const InputField = (props) => {
  const [startDate, setStartDate] = useState(new Date());
  // for country currency code and flags no nedd to send options :)
  const [option, setOption] = useState([]);
  useEffect(() => {
    let options = [];
    countries.map((item) => {
      options.push({
        id: item.id,
        country: item.code,
        label: (
          <>
            {/* <Flag code={item.code} height="16" />{" "} */}
            {item.dial_code + " " + item.name}
          </>
        ),
        value: item.dial_code + " " + item.name,
      });
    });
    setOption(options);
  }, []);

  switch (props.inputType) {
    case "TEXT":
      return (
        <div className="form-group">
          <Input
            type="text"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            autoComplete="off"
            disabled={props.disabled}
            autoFocus={props.autoFocus}
            style={{
              backgroundColor: getValue(props, `color`, "") ? props.color : "",
            }}
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );
    case "TEXTAREA":
      return (
        <div className="form-group mb-0">
          <Input
            type="textarea"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            // autoComplete="off"
            rows={props.rows ? props.rows : 3}
            autoComplete="off"
            disabled={props.disabled}
            className="add-comments-popup__form-control"
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );
    case "TEXTAREA_COMMON":
      return (
        <div className="form-group mb-0">
          <Input
            type="textarea"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            // autoComplete="off"
            rows={props.rows ? props.rows : 3}
            autoComplete="off"
            disabled={props.disabled}
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

    case "TEXTAREAVENDOR":
      return (
        <div className="form-group mb-0">
          <Input
            type="textarea"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            // autoComplete="off"
            rows={props.rows ? props.rows : 3}
            autoComplete="off"
            disabled={props.disabled}
            className="add-comments-popup__form-control add-comments-popup__form-control--vendor"
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );
    case "TEXTALPHA":
      return (
        <div className="form-group">
          <Input
            type="text"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            autoComplete="off"
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label}{' '} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required|alpha",
              )}
            </span>
          )}
        </div>
      );
    case "EMAIL":
      return (
        <div className="form-group">
          <Input
            type="email"
            autoComplete={
              getValue(props, `autoComplete`, "")
                ? getValue(props, `autoComplete`, "")
                : "off"
            }
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            disabled={props.disabled}
            onKeyDown={props.onKeyDown}
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label}{' '} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required|email",
              )}
            </span>
          )}
        </div>
      );
    case "NUMBER":
      return (
        <div className="form-group">
          <Input
            autoComplete="off"
            type="number"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
            disabled={props.disabled}
            maxLength={props.maxLength}
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label}{' '} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required|integer",
              )}
            </span>
          )}
        </div>
      );
    case "PHONE":
      return (
        <div className="form-group">
          <Input
            autoComplete="off"
            type="number"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            value={props.value}
            placeholder={props.placeholder}
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label}{' '} */}
            {props.required ? <span className="form-imp">*</span> : ""}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required|integer|size:10",
              )}
            </span>
          )}
        </div>
      );

    // case "PHONE_NUMBER":
    //   return (
    //     <div className="form-group">
    //       <Input
    //         autoComplete="off"
    //         type="number"
    //         id={props.id}
    //         name={props.name}
    //         onChange={(e) => props.onChange(e, props.setPath)}
    //         value={props.value}
    //         placeholder={props.placeholder}
    //       />
    //       <label className="on-hover" htmlFor={props.id}>
    //         {props.label}
    //       </label>
    //       {props.validator && (
    //         <span className="form-error">
    //           {props.validator.current.message(
    //             props.label,
    //             props.value,
    //             "required|integer|size:10"
    //           )}
    //         </span>
    //       )}
    //     </div>
    //   );
    case "PASSWORD":
      return (
        <div className="form-group">
          <Input
            type="password"
            autoComplete={
              getValue(props, `autoComplete`, "")
                ? getValue(props, `autoComplete`, "")
                : "off"
            }
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            placeholder={props.placeholder}
            onKeyDown={props.onKeyDown}
          />
          <label className="on-hover" htmlFor={props.id}>
            {/* {props.label} */}
          </label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

    case "INPUT_SELECT":
      return (
        <div className="form-group mb-0">
          <Input
            type="select"
            multiple={props.isMulti}
            name={props.name}
            className="form-control m-0"
            onChange={(e) => props.onChange(e, props.setPath)}
          >
            <option>Select {props.label}</option>
            {props.options.map((items) => (
              <option
                value={items[props.valueInput]}
                selected={
                  items[props.valueInput] === props.selectedItem ? true : false
                }
              >
                {items[props.textInput]}
              </option>
            ))}
          </Input>
          <Label className="on-hover">{props.label}</Label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

    // phone number with country flag
    case "INPUT_REACT_SELECT_COUNTYCODE":
      return (
        <div className="form-group form-react-select m-0">
          <Select
            type="select"
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            options={option}
            value={props.value}
            placeholder={getValue(props, `placeholder`, "Select")}
          ></Select>
          {/* <Label className="on-hover on-top">
						{props.label?props.label:'Country Code'}
						{props.required ? <span className="form-imp">*</span> : ""}
					</Label> */}
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );
    case "INPUT_REACT_SELECT":
      return (
        <div className={`form-group m-0 ${props?.customClass}`}>
          <Select
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            options={props.options}
            value={props.value}
            placeholder={getValue(props, `placeholder`, "Select")}
            isClearable={props.isClear ? props.isClear : false}
            isMulti={props.isMulti}
            className={`configure-wrapper__form-control`}
            isDisabled={props.disabled}
            components={{ DropdownIndicator }}
            onInputChange={props.onInputChange}
          ></Select>
          {/* <Label className="on-hover on-top">
						{props.label}
						{props.required ? <span className="form-imp">*</span> : ""}
					</Label> */}
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

      // case "INPUT_REACT_SELECT_MODAL":
      return (
        <div className={`form-group m-0 ${props?.customClass}`}>
          <Select
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            options={props.options}
            value={props.value}
            placeholder={getValue(props, `placeholder`, "Select")}
            isClearable={props.isClear ? props.isClear : false}
            isMulti={props.isMulti}
            className={
              props.class
                ? props.class
                : `configure-wrapper__form-control_modal`
            }
            isDisabled={props.disabled}
            menuPortalTarget={props?.menuPortalTarget}
            menuPosition={props?.menuPosition}
            styles={props?.styles}
          ></Select>
          {/* <Label className="on-hover on-top">
            {props.label}
            {props.required ? <span className="form-imp">*</span> : ""}
          </Label> */}
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );
    case "INPUT_REACT_SELECT_MODAL":
      return (
        <div className={`form-group m-0 ${props?.customClass}`}>
          <Select
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            options={props.options}
            value={props.value}
            placeholder={getValue(props, `placeholder`, "Select")}
            isClearable={props.isClear ? props.isClear : false}
            isMulti={props.isMulti}
            className={
              props.class
                ? props.class
                : `configure-wrapper__form-control_modal`
            }
            isDisabled={props.disabled}
            menuPortalTarget={props?.menuPortalTarget}
            menuPosition={props?.menuPosition}
            styles={props?.styles}
          ></Select>
          {/* <Label className="on-hover on-top">
            {props.label}
            {props.required ? <span className="form-imp">*</span> : ""}
          </Label> */}
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

    case "INPUT_REACT_SELECT_DOB":
      return (
        <div className="form-group">
          <Select
            name={props.name}
            onChange={(val, e) =>
              props.path
                ? props.onChange(
                    props.type,
                    { target: { ...e, ...val } },
                    props.path,
                    props.keyItem,
                  )
                : props.onChange(
                    props.type,
                    { target: { ...e, ...val } },
                    props.keyItem,
                  )
            }
            options={props.options}
            // value={getValue(props,`value.value`,'')?props.value:''}
            value={props.options.filter(
              (obj) => parseInt(obj.value) === parseInt(props.selectedOption),
            )}
            placeholder={props.selectName}
            selectedOption={props.selectedOption}
            classNamePrefix="fct"
            className="configure-wrapper__form-control fct-select"
          ></Select>
          <Label className="on-hover on-top">
            {props.label}
            {props.required ? <span className="form-imp">*</span> : ""}
          </Label>
        </div>
      );
    case "INPUT_REACT_SELECT_CSC":
      return (
        <div className="form-group">
          <Select
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            options={props.options}
            value={getValue(props, `value.value`, "") ? props.value : ""}
            placeholder="Select"
          ></Select>
          <Label className="on-hover on-top">
            {props.label}
            {props.required ? <span className="form-imp">*</span> : ""}
          </Label>
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

    case "CHECKBOX":
      return (
        <label className="checkbox-container">
          {props.label}
          <input
            type="checkbox"
            onChange={() => props.onChange(props.list)}
            value={props.value}
            checked={props.checked(props.list)}
          />
          <span className="checkmark"></span>
        </label>
      );

    // calendar
    case "DATETYPE-1":
      return (
        <ReactDatePicker
          selected={props.selected}
          onChange={(date) => props.onChange(date)}
          isClearable
          minDate={props.minDate}
          maxDate={props.maxDate}
          inline
          selectsStart={props.selectsStart}
          selectsEnd={props.selectsEnd}
          startDate={props.startDate}
          endDate={props.endDate}
          monthsShown={2}
          className="calendar-form-control"
        />
      );
    case "DATETYPE-2":
      return (
        <ReactDatePicker
          selected={props.selected}
          onChange={(date) => props.onChange(date)}
          isClearable
          inline
          minDate={props.minDate}
          maxDate={props.maxDate}
          selectsStart={props.selectsStart}
          selectsEnd={props.selectsEnd}
          startDate={props.startDate}
          endDate={props.endDate}
          monthsShown={1}
        />
      );

    case "TIMETYPE-1":
      return (
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          timeCaption="Time"
          inline
          dateFormat="h:mm aa"
        />
      );

    case "DATETYPE":
      return (
        <div className="form-group">
          <DatePicker
            className="react-date-picker__inputGroup__input"
            selected={props.value}
            onChange={(date) => props.onChange(date)}
            startDate={props.startDate}
            dropdownMode="select"
            maxDate={props.maxDate}
            minDate={props.minDate}
            placeholderText={props.placeholder}
            dateFormat="d MMM yyyy"
          />
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
          {/* <Label className="on-hover on-top">{props.label}</Label> */}
        </div>
      );

    case "DATETYPE-DOB":
      return (
        <div className="form-group">
          <DatePicker
            className="react-date-picker__inputGroup__input react-date-picker__inputGroup__input--location"
            selected={props.value}
            onChange={(date) => props.onChange(date)}
            peekNextMonth
            startDate={props.startDate}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={props.maxDate}
            minDate={props.minDate}
            placeholderText={props.placeholderText}
            // dateFormat={props.format}
            dateFormat="d MMMM yyyy"
            disabled={props.disabled}
          />
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
          {/* <Label className="on-hover on-top">{props.label}</Label> */}
        </div>
      );
    case "DATETYPE-DOB-MODAL":
      return (
        <div className="form-group">
          <DatePicker
            className="react-date-picker__inputGroup__input_modal react-date-picker__inputGroup__input--location"
            selected={props.value}
            onChange={(date) => props.onChange(date)}
            peekNextMonth
            startDate={props.startDate}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            maxDate={props.maxDate}
            minDate={props.minDate}
            placeholderText={props.placeholderText}
            disabled={props.disabled}
            dateFormat="d MMMM yyyy"
          />
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
          {/* <Label className="on-hover on-top">{props.label}</Label> */}
        </div>
      );

    // FOR REFERENCE LOOK profile.js
    case "TIME_ZONE":
      return (
        <div className="form-group">
          <TimezonePicker
            className="form-control-timezone w-100"
            id={props.id}
            name={props.name}
            onChange={(e) => props.onChange(e, props.setPath)}
            inputProps={props.inputProps}
            value={props.value}
            placeholder={props.placeholder}
          />
          {/* <label className="on-hover on-top" htmlFor={props.id}>
						{props.label}
					</label> */}
          {props.validator && (
            <span className="form-error">
              {props.validator.current.message(
                props.label,
                props.value,
                "required",
              )}
            </span>
          )}
        </div>
      );

    default:
      return <h1>Input not valid</h1>;
  }
};
export default InputField;
